import React from "react";

// Assuming 'theme' and 'onClick' are props you're already using,
// add 'className' to the props interface or type.
interface CustomButtonProps {
  theme: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  className?: string; // Make className optional
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  theme,
  onClick,
  children,
  className,
  type,
  disabled,
}) => {
  const baseClass = "py-2 px-4 rounded cursor-pointer select-none"; // Example base classes

  // Use a switch statement to handle different themes
  let themeClass;
  switch (theme) {
    case "navy":
      themeClass = "bg-blue_navy text-white";
      break;
    case "royal":
      themeClass = "bg-blue_royal text-white";
      break;
    case "grey":
      themeClass = "bg-grey_prim text-white";
      break;
    case "gray":
      themeClass = "bg-grey_prim text-white";
      break;
    case "green":
      themeClass = "bg-green text-white";
      break;
    case "red":
      themeClass = "bg-red text-white";
      break;
    default:
      themeClass = ""; // Default case if theme is not recognized
  }

  const combinedClassNames = `${baseClass} ${themeClass} ${
    className || ""
  }`.trim();

  return (
    <button
      className={combinedClassNames}
      type={type}
      disabled={disabled}
      onClick={(event) => {
        event.preventDefault();
        onClick(event);
      }}
    >
      {children}
    </button>
  );
};

export default CustomButton;
